import { render, staticRenderFns } from "./confirmPayment.vue?vue&type=template&id=15be062f&scoped=true"
import script from "./confirmPayment.vue?vue&type=script&lang=js"
export * from "./confirmPayment.vue?vue&type=script&lang=js"
import style0 from "./confirmPayment.vue?vue&type=style&index=0&id=15be062f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be062f",
  null
  
)

export default component.exports